import {
  Mention,
  MentionsInput,
  SuggestionDataItem,
  OnChangeHandlerFunc
} from "react-mentions";

import parse, {
  DOMNode,
  domToReact,
  Element,
  HTMLReactParserOptions
} from "html-react-parser";

import React, { Ref } from "react";

import { Box } from "@chakra-ui/react";

import {
  resolveTestId,
  scopedTestIds,
  type TestIdProps
} from "../utils/test-ids";

import { MENTIONS_CLASSNAME, OLD_MENTIONS_CLASSNAME } from "./constants";
import classNames from "./mentions.module.css";

interface MentionsProps extends TestIdProps {
  trigger: "@";
  value: string;
  showText?: boolean;
  singleLine?: boolean;
  data: SuggestionDataItem[];
  inputRef?: Ref<HTMLTextAreaElement>;
  onChange?: OnChangeHandlerFunc;
  a11ySuggestionsListLabel?: string;
  dataAttributesInsideMentions?: { [key: string]: string };
}

function Mentions(props: MentionsProps) {
  const {
    showText,
    a11ySuggestionsListLabel,
    singleLine = false,
    trigger = "@",
    inputRef,
    onChange,
    value,
    data
  } = props;

  if (showText) {
    const options: HTMLReactParserOptions = {
      replace: (domNode) => {
        if (
          domNode instanceof Element &&
          (domNode.attribs.class === MENTIONS_CLASSNAME ||
            domNode.attribs.class === OLD_MENTIONS_CLASSNAME)
        ) {
          return (
            <Box
              as="span"
              fontWeight={500}
              color="brand.500"
              textDecoration="underline"
            >
              {domToReact(domNode.children as DOMNode[])}
            </Box>
          );
        }

        return;
      }
    };
    return <>{parse(value, options)}</>;
  }

  const MentionsInputComponent = MentionsInput as any;
  const MentionComponent = Mention as any;

  const t = scopedTestIds(resolveTestId(props));

  return (
    <Box {...t.props()}>
      <MentionsInputComponent
        value={value}
        onChange={onChange}
        singleLine={singleLine}
        classNames={classNames}
        inputRef={inputRef}
        allowSuggestionsAboveCursor
        a11ySuggestionsListLabel={a11ySuggestionsListLabel}
        {...t.props("input")}
        style={{
          suggestions: {
            marginTop: singleLine ? 28 : 26
          }
        }}
      >
        <MentionComponent
          data={data}
          appendSpaceOnAdd
          trigger={trigger}
          className={classNames.mentions__mention}
          style={{ fontWeight: 400 }}
          displayTransform={(_, display) => `${trigger}${display}`}
          markup={`<span class="${MENTIONS_CLASSNAME}">__display__</span>`}
        />
      </MentionsInputComponent>
    </Box>
  );
}

export { Mentions };
export type { MentionsProps };
